export default {
  path: '/exportation',
  component: () => import('@/views/exportation/index.vue'),
  children: [
    {
      path: 'distributors',
      name: 'ExportDistributors',
      component: () => import('@/views/exportation/pages/Distributors.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'accounting_manager',
          'accounting',
          'merchandiser',
          'support'
        ]
      }
    },
    {
      path: 'distributors/create',
      name: 'ExportDistributorsCreate',
      component: () => import('@/views/exportation/pages/DistributorForm.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'accounting_manager',
          'accounting',
          'merchandiser',
          'support'
        ]
      }
    },
    {
      path: 'distributors/:id',
      name: 'ExportDistributorsEdit',
      component: () => import('@/views/exportation/pages/DistributorForm.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'accounting_manager',
          'accounting',
          'merchandiser',
          'support'
        ]
      }
    },
    {
      path: 'countries',
      name: 'ExportCountries',
      component: () => import('@/views/exportation/pages/Countries.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'accounting_manager',
          'accounting',
          'merchandiser',
          'support'
        ]
      }
    },
    {
      path: 'products-display',
      name: 'ExportProductsDisplay',
      component: () => import('@/views/exportation/pages/ProductsDisplay.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'accounting_manager',
          'accounting',
          'merchandiser',
          'support'
        ]
      }
    },
    {
      path: 'collections-display',
      name: 'ExportCollectionsDisplay',
      component: () => import('@/views/exportation/pages/CollectionsDisplay.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'accounting_manager',
          'accounting',
          'merchandiser',
          'support'
        ]
      }
    },
    {
      path: 'price-conversions',
      name: 'ExportPriceConversions',
      component: () => import('@/views/exportation/pages/PriceConversions.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'accounting_manager',
          'accounting',
          'merchandiser',
          'support'
        ]
      }
    },
    {
      path: 'product-information',
      name: 'ProductInformation',
      component: () => import('@/views/exportation/pages/ProductInformation.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'accounting_manager',
          'accounting',
          'merchandiser',
          'support'
        ]
      }
    },
    {
      path: 'b2b-wms-status',
      name: 'ExportB2BWmsStatus',
      component: () => import('@/views/exportation/pages/B2BWmsStatus.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'accounting_manager',
          'accounting',
          'merchandiser',
          'support'
        ]
      }
    }
  ]
}
